import React from "react";
import { ArrayInput, BooleanInput, minLength, required, SelectInput, SimpleFormIterator, TextInput } from "react-admin";
import { useFormContext } from "react-hook-form";

// Types
import { CreateOrganizationProps } from "../../types/organizations";

// Constants
import { roles } from "../../constants/roles";

// Hooks
import useValidators from "../../hooks/useValidators";

// Components
import AddMember from "./AddMember";
import DeleteMember from "./DeleteMember";

type EditOrganizationFormProps = {
  formData: CreateOrganizationProps;
};

export const EditOrganizationForm: React.FC<EditOrganizationFormProps> = ({ formData }) => {
  const formContext = useFormContext();
  const { text, role } = useValidators();

  const addUser = (index: number) => {
    const users = formContext.getValues("users");

    const members = formContext.getValues("members");
    const newListMembers = [...members, { role: "", user: users[index] }];

    users.splice(index, 1);

    formContext.setValue("members", newListMembers, { shouldDirty: true });
    formContext.setValue("users", users, { shouldDirty: true });
  };

  const deleteMember = (index: number) => {
    const users = formContext.getValues("users");
    const members: any[] = formContext.getValues("members");

    const newListUsers = [...users, members[index].user];
    members.splice(index, 1);

    formContext.setValue("members", members, { shouldDirty: true });
    formContext.setValue("users", newListUsers, { shouldDirty: true });
  };

  return (
    <>
      <TextInput
        label="Title"
        source="name"
        defaultValue="1"
        onChange={(event) => formContext.setValue("name", event.target.value)}
        validate={text}
      />
      <BooleanInput value={formData.active} label="Active" source="active" />
      <BooleanInput value={formData.isTecheat} label="Is Techeat" source="isTecheat" />
      <ArrayInput source="members">
        <SimpleFormIterator
          removeButton={<DeleteMember onClick={deleteMember} />}
          disableClear
          disableAdd
          disableReordering
          inline
        >
          <TextInput readOnly source="user.email" helperText={false} />
          <SelectInput source="role" emptyText="No organization selected" choices={roles} validate={role} />
        </SimpleFormIterator>
      </ArrayInput>
      <ArrayInput source="users">
        <SimpleFormIterator
          disableClear
          disableAdd
          disableReordering
          removeButton={<AddMember onClick={addUser} />}
          inline
        >
          <TextInput readOnly source="email" helperText={false} />
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};
